import { create } from 'zustand'
import { getToken, setToken, TOKEN_KEY } from '@/api/client'
import type { User } from '@/api/types'

interface AuthState {
  token: string | null
  user: User | null
  ready: boolean
  /** 登录成功 */
  setAuth: (token: string, user: User) => void
  /** 更新用户信息（如改资料/头像后） */
  setUser: (user: User | null) => void
  /** 退出登录（清 token） */
  logout: () => void
  /** 从 localStorage 恢复会话 */
  restore: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: getToken(),
  user: null,
  ready: true,
  setAuth: (token, user) => {
    setToken(token)
    set({ token, user })
  },
  setUser: (user) => set({ user }),
  logout: () => {
    setToken(null)
    set({ token: null, user: null })
  },
  restore: () => {
    const t = getToken()
    set({ token: t, ready: true })
  },
}))

/** 401 事件：任何 API 401 都会触发清理并跳转登录 */
export function setupAuthEvents() {
  window.addEventListener('asg:unauthorized', () => {
    const state = useAuthStore.getState()
    if (state.token) {
      state.logout()
      const current = window.location.pathname + window.location.search
      if (!current.startsWith('/login') && !current.startsWith('/register')) {
        window.location.href = `/login?redirect=${encodeURIComponent(current)}`
      }
    }
  })
}

export const AUTH_TOKEN_KEY = TOKEN_KEY
